export default __webpack_public_path__ + "static/feature-cohorts@2x-aa0a46efe261f26699cf1fadbd8e7487.png";